import React from 'react';
interface AvatarCalloutProps {
  name: string;
  quote: React.ReactNode;
}
export function AvatarCallout({
  name,
  quote
}: AvatarCalloutProps) {
  return;
}